import { types } from "../types/types";

const intitalState = {
    dashboardData: {
        revenue: [],
        channelBreakdown: [],
        planBreakdown: [],
        filters: { availableYears: [] },
        summary: { totalRevenue: 0, totalPurchases: 0, averageOrderValue: 0 },
    },
    newOrdersCount: {},
};

const dashboardReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.DASHBOARD:
            return {
                ...state,
                dashboardData: action.payload,
            };

        case types.NEW_ORDERS_COUNT:
            return {
                ...state,
                newOrdersCount: action.payload,
            };
        default:
            return { ...state };
    }
};

export default dashboardReducer;
